<template>
  <div>
    <div style="padding: 10px; min-height: 100px">
      <x-table
        listApi="biz.customer.order.channel.list"
        paginationLayout="total, sizes, prev, next, jumper"
        defaultSort="opt_status asc"
        actionFixed="right"
        emptyLabel="暂无订单渠道信息"
        :btnList="btnList"
        :defaultParams="defaultParams"
        :fieldList="fieldList"
        :actionList="actionList"
        :actionWidth="120"
      >
        <template slot="row-info" slot-scope="scope">
          <div>
            {{ scope.row.name }}
          </div>
          <div style="color: #919191">
            {{ scope.row.desc || "无说明" }}
          </div>
        </template>
      </x-table>
    </div>
  </div>
</template>

<script>
import formPage from "./__order_channel_form.vue";

export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return Object.assign({
      }, this.queryModel || {});
    },
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  methods: {
    clearClick() {
      this.formInline = {
        queryValue: ""
      }
      this.queryModel = {};
    },
    queryClick() {
      this.queryModel = Object.assign({
      }, this.formInline);
    },
  },
  data() {
    return {
      queryModel: {},
      formInline: {
        nameLike: ''
      },
      fieldList: [
        {
          label: "订单渠道信息",
          minWidth: "240",
          slot: 'info',
        },
      ],
      actionList: [
        {
          label: '编辑',
          show: (row) => {
            if (!this.$hasPower([
              "optSuper",
              "biz.customer.order.channel.update"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '编辑订单渠道信息',
              refresh,
              component: formPage,
              params: {
                guid: row.guid,
              },
            });
          },
        },
        {
          label: "删除",
          linkType: 'danger',
          show: (row) => {
            if (!this.$hasPower([
              "optSuper",
              "biz.customer.order.channel.delete"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            this.$confirm(`确定删除，此操作不可恢复，请谨慎操作?`, '提示', {
              type: 'warning',
            }, {
              showError: true
            }).then(() => {
              this.requestApi('biz.customer.order.channel.delete', {
                guid: row.guid,
              }, {
                showError: true
              }).then(() => {
                this.success('保存成功');
                this.$drawer.refreshDrawer();
                refresh && refresh();
              });
            });
          },
        },
      ],
      btnList: [
        {
          label: '新增订单渠道',
          type: 'primary',
          show: (row) => {
            if (!this.$hasPower([
              "optSuper",
              "biz.customer.order.channel.create"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '新增订单渠道',
              refresh,
              component: formPage,
              params: this.defaultParams,
            });
          },
        }
      ],
    };
  }
};
</script>